
















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetCrfStatistics, GetPatients } from "@/request/projects";
import Copy from "@/components/copy.vue";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../../sjzx/modules/zbsjk/components/nav-left.vue";
import echarts from "echarts";
@Component({
  components: {
    Copy,
    Pagination,
    MainHeader,
    LeftNav,
  },
})
export default class ProjectCrfStatistics extends Vue {
  private title: any = "";
  private id: any = "";
  private data: any = {};
  private list: any = [];
  private currentPage: any = 1;
  private pageCount: any = 10;
  private total: any = 0;
  private totalPage: any = 0;
  private state: any = "";

  /**
   * @description 搜索
   */
  private search() {
    this.currentPage = 1;
    this.getList();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.getList();
  }
  /**
   * @description 获取统计信息
   */
  private GetStatistics() {
    const params = {
      params: {
        template_id: this.id,
      },
    };
    GetCrfStatistics(this, params).then((res) => {
      this.data = res;
      this.data["统计详情"]["data"].forEach((ele, i) => {
        ele.value = ele.count;
        ele.name = ele.title;
      });
      const Chart: any = echarts.init(this.$refs.pie as HTMLCanvasElement);
      const option = {
        title: {
          text: "",
          textStyle: {
            fontSize: 18,
            color: "#666",
            fontWeight: "normal",
          },
          left: "20px",
          top: "20px",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        color: ["#334B5C", "#C23531"],
        series: [
          {
            name: "患者数",
            type: "pie",
            radius: [0, "85%"],
            data: this.data["统计详情"]["data"],
          },
        ],
      };
      Chart.setOption(option);
      // 点击事件
      Chart.off("click");
      Chart.on("click", (p: any) => {
        this.state = p.data.title;
        this.currentPage = 1;
        this.getList();
      });
    });
  }
  /**
   * @description 获取患者列表
   */
  private getList() {
    const params = {
      template_id: this.id,
      提交: this.state,
      current_page: this.currentPage,
      page_count: this.pageCount,
    };
    GetPatients(this, params).then((res) => {
      console.log("患者列表");
      console.log(res);
      this.list = res.patients;
      this.total = res.total_count;
      this.totalPage = res.total_page;
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (!this.$route.query.template_id) {
      this.$message.error("参数有误");
      this.$router.back();
      return;
    }
    this.id = this.$route.query.template_id;
    this.title = this.$route.query.title;
    this.GetStatistics();
    this.getList();
  }
}
